export default {

    setInitialPrestationsMap: (state) => { 
        const obj = {}
        if (!state.initialPrestationsArray || state.initialPrestationsArray.length === 0) return obj
        state.initialPrestationsArray.forEach((prest) => obj[prest.prestationId] = prest)
        state.initialPrestationsMap = obj
    },

}